<template>
  <!-- Formester Branding on Free plan -->
  <div class="formester-branding" :style="{ backgroundColor: firstColor }">
    <a href="https://formester.com" target="_blank">
      <div class="branding-box">
        <FormesterIcon :color="secondColor" />
        <div class="formester-branding__text" :style="{ color: secondColor }">
          Made with Formester
        </div>
      </div>
    </a>
  </div>
</template>

<script setup>
import { computed } from "vue";
import FormesterIcon from "@/components/icons/formester.vue";

const props = defineProps({
  isMultipageForm: {
    type: Boolean,
    required: true,
  },
  firstColor: {
    type: String,
    required: true,
  },
  secondColor: {
    type: String,
    required: true,
  },
});
</script>

<style>
.formester-branding {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  padding: 10px 14px;
  text-align: center;
  box-shadow:
    0px 2px 4px -2px #1018280f,
    0px 4px 8px -2px #1018281a;
  font-size: 14px;
  font-weight: 700;
}

.branding-box {
  display: flex;
  flex-direction: row;
}

.formester-branding__text {
  margin-left: var(--spacing-2);
  font-size: 14px;
  font-weight: 600;
}

.formester-branding img {
  width: 18px;
}

.formester-branding:hover {
  box-shadow:
    0px 4px 8px rgba(0, 0, 0, 0.05),
    0px 2px 4px rgba(0, 0, 0, 0.25);
}

@media screen and (max-width: 576px) {
  .formester-branding {
    transform: scale(0.85) translateX(-23px);
  }
}
</style>
